module.exports = __webpack_public_path__ + "static/toolsHeaderImage-954200cb0a6af00b7c99fef8f6cfcd78.png";